import React from 'react';
import { Stack, Typography } from '@mui/material';
import { capitalizeFirstLetter } from 'formatters';

import { Details } from './Details';
import {
  EMPTY_VALUE,
  getFeeAmount,
  formatCapText,
  formatEnumText,
  getChangeAction,
  formatBooleanText,
  formatCurrencyText,
} from './lib';

interface Props {
  value: Record<string, any>;
}

export const FeesChanges = ({ value }: Props) => {
  const { before, after } = value;
  const action = getChangeAction(before, after);

  const title = (after ?? before)?.description;

  const getFeeRows = (
    before: Record<string, any> | null | undefined,
    after: Record<string, any> | null | undefined
  ) => [
    {
      label: 'Description',
      before: before?.description ?? EMPTY_VALUE,
      after: after?.description ?? EMPTY_VALUE,
      rawBefore: before?.description,
      rawAfter: after?.description,
    },
    {
      label: 'Type',
      before: formatEnumText(before?.type),
      after: formatEnumText(after?.type),
      rawBefore: before?.type,
      rawAfter: after?.type,
    },
    {
      label: 'Amount',
      before: formatCurrencyText(getFeeAmount(before)),
      after: formatCurrencyText(getFeeAmount(after)),
      rawBefore: getFeeAmount(before),
      rawAfter: getFeeAmount(after),
    },
    {
      label: 'Taxable',
      before: formatBooleanText(before?.isTaxable),
      after: formatBooleanText(after?.isTaxable),
      rawBefore: before?.isTaxable,
      rawAfter: after?.isTaxable,
    },
    {
      label: 'Customer Visibility',
      before: formatEnumText(before?.customerVisibility),
      after: formatEnumText(after?.customerVisibility),
      rawBefore: before?.customerVisibility,
      rawAfter: after?.customerVisibility,
    },
    {
      label: 'Amount Type',
      before: formatEnumText(before?.amountType),
      after: formatEnumText(after?.amountType),
      rawBefore: before?.amountType,
      rawAfter: after?.amountType,
    },
    {
      label: 'Cap',
      before: formatCapText(before?.cap),
      after: formatCapText(after?.cap),
      rawBefore: before?.cap,
      rawAfter: after?.cap,
    },
  ];

  return (
    <Stack>
      <Typography variant="body2" fontWeight={500}>
        {`${capitalizeFirstLetter(action)}: ${title}`}
      </Typography>

      <Details action={action} rows={getFeeRows(before, after)} />
    </Stack>
  );
};
